import {
  Flex,
  Box,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  HStack,
  InputRightElement,
  Stack,
  Button,
  Heading,
  Text,
  useColorModeValue,
  FormErrorMessage,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { useState } from "react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { useRef } from "react";
import axios from "axios";
import { toast } from "react-toastify";

function Register() {
  const [showPassword, setShowPassword] = useState(false);
  const [nameInvalid, setNameInvalid] = useState(false);
  const [emailInvalid, setEmailInvalid] = useState(false);
  const [passwordInvalid, setPasswordInvalid] = useState(false);
  const [loading, setLoading] = useState(false);

  const firstName = useRef();
  const email = useRef();
  const password = useRef();

  const onRegister = () => {
    let error = false;
    if (!firstName.current.value) {
      setNameInvalid(true);
      error = true;
    }

    if (!email.current.value) {
      setEmailInvalid(true);
      error = true;
    }

    if (!password.current.value) {
      setPasswordInvalid(true);
      error = true;
    }

    if (password.current.value.length < 6) {
      toast.error("Your password must be at least 6 characters long");
      error = true;
    }

    if (error) {
      return;
    }

    setLoading(true);

    const params = {
      email: email.current.value,
      password: password.current.value,
      name: firstName.current.value,
    };

    axios
      .post(process.env.REACT_APP_SERVER_URL + "/auth/register", params)
      .then((res) => {
        if (res.data.email) {
          toast.info("An account with this email already exists");
        } else {
          window.location.href = "/login";
        }

        setLoading(false);
      })
      .catch((err) => {
        toast.error("Sorry, something went wrong");
        setLoading(false);
      });
  };

  return (
    <Flex
      minH={"100vh"}
      align={"center"}
      justify={"center"}
      bg={useColorModeValue("gray.50", "gray.800")}
    >
      <Stack spacing={8} w={"420px"} mx={"auto"} maxW={"lg"} py={12} px={6}>
        <Stack align={"center"}>
          <Heading fontSize={"4xl"} textAlign={"center"}>
            Sign up
          </Heading>
        </Stack>
        <Box
          rounded={"lg"}
          bg={useColorModeValue("white", "gray.700")}
          boxShadow={"lg"}
          p={8}
        >
          <Stack spacing={4}>
            <FormControl isInvalid={nameInvalid} id="firstName" isRequired>
              <FormLabel>Name</FormLabel>
              <Input ref={firstName} type="text" />
              <FormErrorMessage>Your name is required</FormErrorMessage>
            </FormControl>
            <FormControl isInvalid={emailInvalid} id="email" isRequired>
              <FormLabel>Email address</FormLabel>
              <Input ref={email} type="email" />
              <FormErrorMessage>Your email is required</FormErrorMessage>
            </FormControl>
            <FormControl isInvalid={passwordInvalid} id="password" isRequired>
              <FormLabel>Password</FormLabel>
              <InputGroup>
                <Input
                  ref={password}
                  type={showPassword ? "text" : "password"}
                />
                <InputRightElement h={"full"}>
                  <Button
                    variant={"ghost"}
                    onClick={() =>
                      setShowPassword((showPassword) => !showPassword)
                    }
                  >
                    {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                  </Button>
                </InputRightElement>
              </InputGroup>
              <FormErrorMessage>Your password is required</FormErrorMessage>
            </FormControl>
            <Stack spacing={10} pt={2}>
              <Button
                isLoading={loading}
                loadingText="Submitting"
                size="lg"
                bg={"blue.400"}
                color={"white"}
                onClick={onRegister}
                _hover={{
                  bg: "blue.500",
                }}
              >
                Sign up
              </Button>
            </Stack>
            <Stack pt={6}>
              <Text align={"center"}>
                Already a user?{" "}
                <Link className="text-blue-500" to="/login">
                  Login
                </Link>
              </Text>
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </Flex>
  );
}

export default Register;
